import axios from "@/gateway/backendapi";

function handleRequest(promise) {
  return new Promise((resolve, reject) => {
    promise
      .then((res) => resolve(res.data))
      .catch((error) => {
        NProgress.done(); // Optional, remove if you don’t use NProgress
        if (error.response) reject(error.response);
        else reject(error);
      });
  });
}

const assetService = {
  /* SEEDCATEGORY */
  seedCategory() {
    return handleRequest(axios.get("/api/Asset/SeedCategory"));
  },
  /* ===========================
     CATEGORY ENDPOINTS
  ============================ */
  getCategories() {
    return handleRequest(axios.get("/api/Asset/category"));
  },
  getAllCategory() {
    return handleRequest(axios.get("/api/Asset/Allcategory"));
  },
  createCategory(data) {
    return handleRequest(axios.post("/api/Asset/category", data));
  },
  getCategoryById(id) {
    return handleRequest(axios.get(`/api/Asset/category/${id}`));
  },
  updateCategory(id, data) {
    return handleRequest(axios.put(`/api/Asset/category/${id}`, data));
  },
  deleteCategory(id) {
    return handleRequest(axios.delete(`/api/Asset/category/${id}`));
  },

  /* ===========================
     SUBCATEGORY ENDPOINTS
     (based on your Swagger)
  ============================ */
  getSubCategories(parentId) {
    return handleRequest(axios.get(`/api/Asset/subcategory/${parentId}`));
  },
  createSubCategory(parentId, data) {
    return handleRequest(
      axios.post(`/api/Asset/subcategory/${parentId}`, data)
    );
  },
  getSubCategoryById(id, parentId) {
    return handleRequest(axios.get(`/api/Asset/subcategory/${id}/${parentId}`));
  },
  updateSubCategory(id, parentId, data) {
    return handleRequest(
      axios.put(`/api/Asset/subcategory/${id}/${parentId}`, data)
    );
  },
  deleteSubCategory(id, parentId) {
    return handleRequest(
      axios.delete(`/api/Asset/subcategory/${id}/${parentId}`)
    );
  },

  /* REQUEST */
  getRequests() {
    return handleRequest(axios.get("/api/Asset/request"));
  },
  createRequest(data) {
    return handleRequest(axios.post("/api/Asset/request", data));
  },
  getRequestById(id) {
    return handleRequest(axios.get(`/api/Asset/request/${id}`));
  },
  updateRequest(id, data) {
    return handleRequest(axios.put(`/api/Asset/request/${id}`, data));
  },
  approveRequest(id) {
    return handleRequest(axios.get(`/api/Asset/request/approve/${id}`));
  },
  deleteRequest(id) {
    return handleRequest(axios.delete(`/api/Asset/request/${id}`));
  },

  /* ISSUE */
  getIssues() {
    return handleRequest(axios.get("/api/Asset/issue"));
  },
  createIssue(data) {
    return handleRequest(axios.post("/api/Asset/issue", data));
  },
  getIssueById(id) {
    return handleRequest(axios.get(`/api/Asset/issue/${id}`));
  },
  updateIssue(id, data) {
    return handleRequest(axios.put(`/api/Asset/issue/${id}`, data));
  },
  deleteIssue(id) {
    return handleRequest(axios.delete(`/api/Asset/issue/${id}`));
  },

  /* ASSET */
  getAssets() {
    return handleRequest(axios.get("/api/Asset"));
  },
  createAsset(data) {
    return handleRequest(axios.post("/api/Asset", data));
  },
  getAssetById(id) {
    return handleRequest(axios.get(`/api/Asset/${id}`));
  },
  updateAsset(id, data) {
    return handleRequest(axios.put(`/api/Asset/${id}`, data));
  },
  deleteAsset(id) {
    return handleRequest(axios.delete(`/api/Asset/${id}`));
  },

  /* MAINTENANCE */
  getMaintenance() {
    return handleRequest(axios.get("/api/Asset/maintenance"));
  },
  createMaintenance(data) {
    return handleRequest(axios.post("/api/Asset/maintenance", data));
  },
  getMaintenanceById(id) {
    return handleRequest(axios.get(`/api/Asset/maintenance/${id}`));
  },
  updateMaintenance(id, data) {
    return handleRequest(axios.put(`/api/Asset/maintenance/${id}`, data));
  },
  deleteMaintenance(id) {
    return handleRequest(axios.delete(`/api/Asset/maintenance/${id}`));
  },

  /* CHARTS */
  getAssetChart() {
    return handleRequest(axios.get("/api/Asset/asset-chart"));
  },
  getAssetRequestChart() {
    return handleRequest(axios.get("/api/Asset/assetrequest-chart"));
  },
  getAssetIssueChart() {
    return handleRequest(axios.get("/api/Asset/assetissue-chart"));
  },
  getAssetMaintenanceChart() {
    return handleRequest(axios.get("/api/Asset/assetmaintenance-chart"));
  },
  getStatusTrend() {
    return handleRequest(axios.get("/api/Asset/GetStatusTrend"));
  },
  getCategoryTrend() {
    return handleRequest(axios.get("/api/Asset/GetCategoryTrend"));
  },
  getAssetCountCategoryTrend() {
    return handleRequest(axios.get("/api/Asset/GetAssetCountCategoryTrend"));
  },
  getAssetValueCategoryTrend() {
    return handleRequest(axios.get("/api/Asset/GetAssetValueCategoryTrend"));
  },
  getAssetCharts() {
    return handleRequest(axios.get("/api/Asset/GetAssetCharts"));
  },
};

export default assetService;
